import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderProjectStatus($projectId: ID!, $status: String!) {
    updateBlogPostBuilderProjectStatus(projectId: $projectId, status: $status) {
      id
      name
      status
    }
  }
`;

interface Params {
  projectId: ID;
  status: string;
}

interface Result {
  id: ID;
  name: string;
  status: string;
}

export const updateBlogPostBuilderProjectStatus = async ({ projectId, status }: Params) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { projectId, status },
  });

  return getSingleProp<Result>(result.data);
};
